import type { ApolloCache } from "@apollo/client/cache"

import { Project } from "shared/types/Project"

import { ProjectDocument } from "entities/projects/graphql/queries.generated"

export function cacheProjects(cache: ApolloCache<object>, projects: Project[]) {
  projects.forEach(project =>
    cache.writeQuery({
      query: ProjectDocument,
      data: { project },
      variables: {
        id: project.id
      }
    })
  )
}
